import { Sparkle } from './Sparkle';

export function ChoiceScreen({
  onContinue,
  onStartNew,
}: {
  onContinue: () => void;
  onStartNew: () => void;
}) {
  return (
    <div class="aj-choice">
      <span class="aj-choice__icon">
        <Sparkle />
      </span>
      <div class="aj-choice__prompt">Pick up where you left off, or start fresh?</div>
      <button type="button" class="aj-choice__btn aj-choice__btn--primary" onClick={onContinue}>
        Continue previous conversation
      </button>
      <button type="button" class="aj-choice__btn" onClick={onStartNew}>
        Start new conversation
      </button>
    </div>
  );
}
